import { createContext, useContext } from "react";
import Context from "./slices/context";

const store = {
  context: new Context(),
};

export const StoreContext = createContext(store);

export const useStore = () => useContext(StoreContext);

export default store;
